import React from 'react'
import { bool, func, string } from 'prop-types'

import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'


import erro from '../../assets/imagens/erro.svg'
import sino from '../../assets/imagens/sino.svg'
import styled from 'styled-components'

const ConteudoWrapper = styled.div`
  border-bottom: 1px solid #D8D8D8;
  margin: ${( { margin } ) => margin ? '30px auto 25px' : '0 auto 25px'} ;
`

const ButtonWrapper = styled.div`
  text-align: center;
`

const Icon = styled.span`
  background-image: url( ${( { urlIcone } ) => urlIcone} );
  background-position: center;
  background-size: cover;
  margin-right: 10px;
  min-height: 30px;
  width: 30px;
`

const Texto = styled.p`
  color: ${( { cor } ) => cor};
  line-height: 1.6;
  margin: 1em 0 1.5em;
`

const Titulo = styled.h3`
  ${StyleGuide.tipografia.textoDefault};
  ${StyleGuide.boldFonte};
  color: ${( { cor } ) => cor};
  margin: 0;
`

const TextoWrapper = styled.div`
  background-color: ${( { background } ) => background};
  border-radius: 10px;
  margin-bottom: 21px;
  padding: 20px;

  @media( max-width: ${StyleGuide.mediaQuery.tablet} ) {
    button {
      margin: 0;
      padding: 20px 20px;
    }
  }
`

const TituloWrapper = styled.div`
  align-items: center;
  display: flex;
`

const ImgWrapper = styled.div`
  text-align: center;
  margin: 5px 0 15px;

  img {
    height: auto;
    max-width: 130px;
  }
`

const Mensagem = ( props ) => {
  const {
    acao,
    handleClick,
    isAlerta,
    texto,
    titulo,
    urlAcao,
    imgUrl,
    resumido
  } = props

  const { cores } = StyleGuide

  return (
    <ConteudoWrapper
      margin={ resumido }
    >
      <TextoWrapper
        background={ isAlerta ? cores.vermelhoErroBackground : cores.azulClaro }
      >
        {
          titulo ?
            <TituloWrapper>
              <Icon
                urlIcone={ isAlerta ? erro : sino }
              />

              <Titulo
                cor={ isAlerta ? cores.vermelhoErroColor : cores.azul }
              >
                { titulo }
              </Titulo>
            </TituloWrapper> : null
        }

        {
          texto ?
            <Texto
              cor={ isAlerta ? cores.vermelhoErroColor : cores.cinza500 }
            >
              { texto }
            </Texto> : null
        }

        {imgUrl ?
          <ImgWrapper>
            <img
              alt="imagem url"
              src={ imgUrl }
            />
          </ImgWrapper> : null}

        {
          acao ?
            <ButtonWrapper>
              <Button
                href={ urlAcao }
                onClick={ () => handleClick() }
                tema={ isAlerta ? Button.BOTAO_VERMELHO : Button.BOTAO_CURADORIA }
              >
                { acao }
              </Button>
            </ButtonWrapper>
            : null
        }
      </TextoWrapper>
    </ConteudoWrapper>
  )
}

Mensagem.propTypes = {
  'acao': string,
  'handleClick': func,
  'imgUrl': string,
  'isAlerta': bool,
  'resumido': bool,
  'texto': string,
  'titulo': string,
  'urlAcao': string
}

Mensagem.defaultProps = {
  'acao': '',
  'handleClick': null,
  'imgUrl': '',
  'isAlerta': false,
  'resumido': false,
  'texto': '',
  'titulo': 'Você tem uma notificação',
  'urlAcao': ''
}

export default Mensagem
